import type { RequestOptions, RequestConfig } from '@@/plugin-request/request';
import { history } from '@umijs/max';
import { jwtDecode } from 'jwt-decode';
import qs from 'query-string';
// import { checkAuth } from './services/auth/checkAuth';
// import { trimData } from './utils/formatter';

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */

// Hàm kiểm tra token còn hạn hay không
const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token) as any;
    return decoded?.exp * 1000 <= Date.now() + 60000; // Xem xét token hết hạn nếu còn dưới 1 phút
  } catch (error) {
    return true;
  }
};

// Hàm refresh token
const refreshAccessToken = async (request: any): Promise<boolean> => {
  try {
    const refreshToken = localStorage.getItem('REFRESH_TOKEN');
    if (!refreshToken) {
      return false;
    }

    const response = await request('/cms-api/auth/refresh-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (response?.data?.accessToken) {
      localStorage.setItem('ACCESS_TOKEN', response.data.accessToken);
      if (response.data.refreshToken) {
        localStorage.setItem('REFRESH_TOKEN', response.data.refreshToken);
      }
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error refreshing token:', error);
    return false;
  }
};

export const errorConfig: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (url: string, options: RequestOptions) => {
      const accessToken = localStorage.getItem('ACCESS_TOKEN');
      const refreshToken = localStorage.getItem('REFRESH_TOKEN');
      const isApiRefresh = url.includes('/cms-api/auth/refresh-token');

      options.headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        ...(options.headers || {}),
        ...((accessToken || refreshToken) && {
          Authorization: `Bearer ${isApiRefresh ? refreshToken : accessToken}`,
        }),
      };

      return {
        url,
        options,
      };
    },
  ],

  responseInterceptors: [
    [
      async (response) => response,

      async (error: any) => {
        const { request } = error.config;

        // Nếu là lỗi 401 (Unauthorized)
        if (error?.response?.status === 401) {
          const refreshToken = localStorage.getItem('REFRESH_TOKEN');

          // Nếu không có refresh token, redirect đến login
          if (!refreshToken) {
            localStorage.removeItem('ACCESS_TOKEN');
            localStorage.removeItem('REFRESH_TOKEN');
            return history.push('/login');
          }

          // Thử refresh token
          const refreshed = await refreshAccessToken(request);

          if (refreshed) {
            // Nếu refresh thành công, retry request ban đầu
            const newAccessToken = localStorage.getItem('ACCESS_TOKEN');
            error.config.headers.Authorization = `Bearer ${newAccessToken}`;
            return request(error.config);
          } else {
            // Nếu refresh thất bại, redirect đến login
            localStorage.removeItem('ACCESS_TOKEN');
            localStorage.removeItem('REFRESH_TOKEN');
            return history.push('/login');
          }
        }

        // Kiểm tra token expiration cho các error khác
        const accessToken = localStorage.getItem('ACCESS_TOKEN');
        if (isTokenExpired(accessToken)) {
          localStorage.removeItem('ACCESS_TOKEN');
          localStorage.removeItem('REFRESH_TOKEN');
          return history.push('/login');
        }

        return Promise.reject(error);
      },
    ],
  ] as RequestConfig['responseInterceptors'],

  timeout: 60000,
  paramsSerializer: (params) => qs.stringify(params),
  baseURL: REACT_APP_BASE_URL,
  transformRequest: (data) => JSON.stringify(data),
};
